import * as React from 'react';
import { connect } from 'react-redux';
import { HashRouter, Redirect, Route, RouteComponentProps } from 'react-router-dom';
import * as _ from 'underscore';

import { ReactDirectiveProps } from '../../../ts/directives/reactDirectiveFactory';
import { siteUrlsSelector } from '../../selectors/SiteUrlsSelectors';
import { AppState } from '../../state/AppState';
import { GroupSubspaceName } from '../../state/SpaceInfo';
import { MapStateToProps } from '../../utils/ConnectUtils';
import { RouterError } from '../RouterHelpers/RouterError';
import { TableauReactRouterSwitch } from '../RouterHelpers/TableauReactRouterSwitch';
import { SpacesSiteUrls } from '../SpacesSiteUrls';
import { GroupSpaceProvider, GroupSpaceProviderProps } from './GroupSpaceProvider';
import { AllGroupsSpaceProvider, AllGroupsSpaceProviderProps } from './GroupsSpaceProvider';

export interface SpaceRouteParams {
  readonly id: string;
}

export interface GroupRouteComponentProps extends RouteComponentProps<SpaceRouteParams> {}

export interface GroupSpaceRouterOwnProps extends ReactDirectiveProps {}

export interface GroupSpaceRouterStateProps {
  readonly urls: SpacesSiteUrls;
  readonly routerReactKey: number;
}

export type GroupSpaceRouterProps = GroupSpaceRouterOwnProps & GroupSpaceRouterStateProps;

export class GroupSpaceRouterComponent extends React.PureComponent<GroupSpaceRouterProps> {

  public render() {
    return (
      <HashRouter key={'group-space-router-' + this.props.routerReactKey}>
        <TableauReactRouterSwitch basePaths={[this.props.urls.groupsPath()]} urls={this.props.urls}>
          <Route exact path={this.props.urls.groupsPath()} render={this.groupsProvider} />
          <Route exact path={this.props.urls.groupUsersPath(':id')} render={this.provider('users')} />
          <Route exact path={this.props.urls.groupDetailsPath(':id')} render={this.provider('details')} />
          <Route exact path={this.props.urls.groupPath(':id')} render={({ match }) => (
            <Redirect to={this.props.urls.groupUsersPath(match.params.id)} />
          )} />
          <Route render={this.error} />
        </TableauReactRouterSwitch>
      </HashRouter>
    );
  }

  private provider = (subspaceName: GroupSubspaceName): (props: RouteComponentProps) => JSX.Element => {
    return (props: GroupRouteComponentProps): JSX.Element => {
      const groupSpaceProps: GroupSpaceProviderProps = {
        urls: this.props.urls,
        subspaceName,
        routeLocationSearch: props.location.search,
        routeLocationPath: null,
        angularContext: this.props.angularContext,
        groupId: props.match.params.id
      };

      return <GroupSpaceProvider {...groupSpaceProps}/>;
    };
  }

  private error = (_props: RouteComponentProps): JSX.Element => {
    return <RouterError errorType={'default'} urls={this.props.urls}/>;
  }

  private groupsProvider = (): JSX.Element => {
    const groupsSpaceProps: AllGroupsSpaceProviderProps = {
      angularContext: this.props.angularContext,
    };
    return <AllGroupsSpaceProvider {...groupsSpaceProps} />;
  }
}

const mapStateToProps: MapStateToProps<GroupSpaceRouterStateProps> = (state: AppState) => ({
  urls: siteUrlsSelector(state),
  routerReactKey: state.routerSpaceReactKey
});

export const GroupSpaceRouter: React.ComponentClass<GroupSpaceRouterOwnProps>
  = connect(mapStateToProps)(GroupSpaceRouterComponent);
